import API from './axios.js';

export const getLawyers = () => API.get('auth/lawyers');